export function trustedHrefDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: trustedHrefDirectiveCtrl,
	};
}

export class trustedHrefDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		$element.attr('href', $scope.$eval($attrs.shTrustedHref));
		$element.removeAttr('sh-trusted-href');
	}
}

export function trustedSrcDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: trustedSrcDirectiveCtrl,
	};
}

export class trustedSrcDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		$element.attr('src', $scope.$eval($attrs.shTrustedSrc));
		$element.removeAttr('sh-trusted-crc');
	}
}
